'use strict';

var Utils = require('../utils/utils');

var Collapse = function(config) {

  var self = this;
  var $item = $(config.item);
  var $link = $(config.link);
  var $subnav = $(config.subnav);
  var $subnavItem = $(config.subnavItem);
  var effect = config.effect || 'slide';

  self.parseItems = function() {
    $item.each(function() {
      var $this = $(this);
      var _$link = $this.find($link);
      var _$subnav = $this.find($subnav);
      var _$subnavItem = $this.find($subnavItem);

      if (_$subnav.length) {
        self.clickHandler(_$link, _$subnav, _$subnavItem);
      }
    });
  }

  self.clickHandler = function(_$link, _$subnav, _$subnavItem) {
    _$link.on('click.subnavCollapse', function(e) {
      e.preventDefault();
      var throttledFn = new Utils().throttle(function() {
        self.subnavVisibility(_$link, _$subnav, _$subnavItem);
      }, 300);
      throttledFn();
    });
  }

  self.subnavVisibility = function(_$link, _$subnav, _$subnavItem) {
    if (_$subnav.hasClass('is-visible') && !_$subnav.hasClass('velocity-animating')) {
      self.hideSubnav(_$link, _$subnav, _$subnavItem);
    } else if (!_$subnav.hasClass('velocity-animating')) {
      self.showSubnav(_$link, _$subnav, _$subnavItem);
    }
  }

  self.showSubnav = function(_$link, _$subnav, _$subnavItem) {
    _$subnavItem.each(function(i) {
      var $this = $(this);
      $this.velocity({
        opacity: 1
      },{
        duration: 360,
        delay: 200 + (i * 40)
      });
    });

    var completeCb = function() {
      _$link.addClass('is-active');
    };

    if (effect === 'slide') {

      _$subnav
        .addClass('is-visible')
        .velocity(
          'slideDown',{
            easing: 'easeOutQuart',
            duration: 500,
            complete: function() {
              completeCb();
            }
          }
        );

    } else if (effect === 'horizontalSlide') {

      _$subnav
        .addClass('is-visible')
        .velocity({
          width: self.getSubnavWidth(_$subnav)
        },{
          display: 'flex',
          easing: 'easeOutQuart',
          duration: 500,
          complete: function() {
            completeCb();
          }
        });

    }
  }

  self.hideSubnav = function(_$link, _$subnav, _$subnavItem) {
    _$subnavItem
      .velocity({
        opacity: 0
      },{
        duration: 400,
        complete: function() {

          var completeCb = function() {
            _$link.removeClass('is-active');
          };

          if (effect === 'slide') {

            _$subnav
              .removeClass('is-visible')
              .velocity(
                'slideUp',{
                  easing: 'easeOutQuart',
                  complete: function() {
                    completeCb();
                  }
                }
              );

          } else if (effect === 'horizontalSlide') {

            _$subnav
              .removeClass('is-visible')
              .velocity({
                width: 0
              },{
                display: 'none',
                easing: 'easeOutQuart',
                complete: function() {
                  completeCb();
                }
              });

          }
        }
      });
  }

  self.getSubnavWidth = function(_$subnav) {
    var $clone = _$subnav
                  .clone()
                  .removeAttr('style')
                  .addClass('is-clone')
                  .css({
                    'visibility': 'hidden',
                    'position': 'absolute',
                    'top': '0'
                  })
                  .appendTo($item.first());
    var width = $clone.outerWidth();
    $clone.remove();
    return width;
  }

  self.destroy = function() {
    $link
      .off('click.subnavCollapse')
      .removeClass('is-active');
    $subnav
      .removeAttr('style')
      .removeClass('is-visible');
    $subnavItem
      .removeAttr('style');
  }

  self.init = function() {
    self.parseItems();
  }
};

module.exports = Collapse;
